export default "__VITE_ASSET__5CmmfXuu__"